export default (config) => ({
    activeTab: config.activeTab ?? '',
    tabs: config.tabs,
    init() {
        // Tabs that should sync to the server (issue main tabs), passed in by the issue view.
        // Other navigation-tabs instances (e.g. per-instance tabs) omit it and never dispatch.
        const mainTabs = config.mainTabs ?? [];
        const splitLocationHash = window.location.hash.slice(1).split("/");
        const TabFromHash = splitLocationHash[0];
        if (TabFromHash && this.tabs.indexOf(TabFromHash) > -1) {
            this.activeTab = TabFromHash;
        } else if (this.activeTab === '') {
            this.activeTab = this.tabs[0];
        }

        if (this.$wire && this.activeTab !== TabFromHash && mainTabs.includes(this.activeTab)) {
            this.$wire.dispatch('activeTabChanged', { data: { activeTab: this.activeTab } });
        }

        if (splitLocationHash[1]) {
            const scrollTo = document.getElementById(
                window.location.hash.substr(1)
            );
            if (scrollTo) {
                scrollTo.scrollIntoView({ behavior: "smooth" });
            }
        }
        if (config.useHashChange) {
            window.addEventListener('hashchange', () => {
                const splitLocationHash = window.location.hash.slice(1).split("/");
                const tabFromHash = splitLocationHash[0];

                if (this.tabs.includes(tabFromHash)) {
                    this.activeTab = tabFromHash;
                }
            });
            
            this.$watch("activeTab", (value) => {
                window.location.hash = value
                if(this.$wire && mainTabs.includes(value)) {
                    clearTimeout(this._dispatchTimer);
                    this._dispatchTimer = setTimeout(() => {
                        // Announce alongside the settled dispatch so arrow-key traversal
                        // across tabs does not flood the live region on every keystroke.
                        this.announceTabLoading();
                        this.$wire.dispatch('activeTabChanged', { data: { activeTab: this.activeTab } });
                    }, 150);
                }
            });
        }
    },
    setActiveTab(tab) {
        this.activeTab = tab;
    },
    announceTabLoading() {
        const statusEl = this.$el.querySelector('[data-tabs-loading-status]');
        if (!statusEl) {
            return;
        }
        const message = statusEl.dataset.loadingMessage;
        if (!message) {
            return;
        }
        // Clear then set on the next frame so switching back to a tab still changes
        // the region's text and re-announces, even when the message is identical.
        statusEl.textContent = '';
        requestAnimationFrame(() => {
            statusEl.textContent = message;
        });
    },
    focusPreviousTab(event) {
        if (event.key === 'ArrowLeft') {
            const currentIndex = this.tabs.indexOf(this.activeTab);
            const previousTab = this.tabs[currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1];
            this.activeTab = previousTab;
            document.querySelector(`#tab-${previousTab}`).focus();
            event.stopPropagation();
            event.preventDefault();
        }
    },
    focusNextTab(event) {
        if (event.key === 'ArrowRight') {
            const currentIndex = this.tabs.indexOf(this.activeTab);
            const nextTab = this.tabs[currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1];
            this.activeTab = nextTab;
            document.querySelector(`#tab-${nextTab}`).focus();
            event.stopPropagation();
            event.preventDefault();
        }
    },
    focusFirstTab(event) {
        if (event.key === 'Home') {
            this.activeTab = this.tabs[0];
            document.querySelector(`#tab-${this.activeTab}`).focus();
            event.stopPropagation();
            event.preventDefault();
        }
    },
    focusLastTab(event) {
        if (event.key === 'End') {
            this.activeTab = this.tabs[this.tabs.length - 1];
            document.querySelector(`#tab-${this.activeTab}`).focus();
            event.stopPropagation();
            event.preventDefault();
        }
    },
});
